import './Table.scss';

type TableRow = {
    [column: string]: any;
};

type TableProps = {
    columns: Array<string>,
    rows: Array<Array<any>>,
    position?: Array<string>,
    filled?: boolean,
    className?: string,
};

function Table(props: TableProps) {

    return (
        <table className={`table-container ${props.filled ? 'filled' : ''} ${props.className}`}>
            <thead>
                <tr>
                    {props.columns.map((column: string, index: number) => (
                        <th key={`th_${index}`}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {props.rows.map((row: Array<any>, index: number) => (
                    <tr key={`tr_${index}`}>
                        {row.map((data: any, index2: number) => (
                            <td key={`tr_${index}_td_${index2}`} className={`text-${props.position ? props.position[index2] : 'left'}`}>{data}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default Table;
